






















































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class ViewComprarBoletos extends Vue {
  @Prop() private msg!: string
  private dialog: boolean = false
  private dialogPay: boolean = false
  private step: number = 1
  private codigoDescuento: string = ''
  private selectDay: number = -1
  private showCreditCard: boolean = false
  private showOXXO: boolean = false
  private showEfectivo: boolean = false
  private days: object = [
    'Jueves - 21/11/2019',
    'Viernes - 22/11/2019',
    'Sabado - 23/11/2019'
  ]
  private datosVenta: object = {
    nombre: 'Comprador',
    email: 'comprador@hotmail.com',
    tarjeta: {
      num: '5555555555554444',
      cvc: '123',
      monthExp: '12',
      yearExp: '22'
    }
  }
  private infoVenta: any = {
    adulto: {
      costo: 180,
      cantidad: 1,
      categoria: 'Adulto'
    },
    infantil: {
      costo: 90,
      cantidad: 0,
      categoria: 'Infantil'
    },
    discapacidad: {
      costo: 100,
      cantidad: 0,
      categoria: 'Discapacidad'
    }
  }

  @Watch('selectDay')
  private watchSelectDay (v: any) {
    if (v >= 0) {
      this.step = 2
    }
  }

  @Watch('codigoDescuento')
  private watchCodigoDescuento (v: any) {
    if (v.length > 0) {
      console.log('Aplicar Descuento', v)
    }
  }

  @Watch('dialogPay')
  private watchDialogPay (v: any) {
    if (!v) return
    setTimeout(() => {
      this.dialogPay = false
      this.step = 4
    }, 3000)
  }

  private addBoleto (type: any) {
    if (type === 'Adulto') {
      ++this.infoVenta.adulto.cantidad
    } else if (type === 'Infantil') {
      ++this.infoVenta.infantil.cantidad
    } else if (type === 'Discapacidad') {
      ++this.infoVenta.discapacidad.cantidad
    }
  }

  private get totalVenta () {
    let res = 0
    res += this.infoVenta.adulto.cantidad * this.infoVenta.adulto.costo
    res += this.infoVenta.infantil.cantidad * this.infoVenta.infantil.costo
    res += this.infoVenta.discapacidad.cantidad * this.infoVenta.discapacidad.costo
    return res
  }

  private get totalBoletos () {
    let res = 0
    res += this.infoVenta.adulto.cantidad
    res += this.infoVenta.infantil.cantidad
    res += this.infoVenta.discapacidad.cantidad
    return res
  }

  private lessBoleto (type: any) {
    if (type === 'Adulto') {
      if (this.infoVenta.adulto.cantidad >= 1) {
        --this.infoVenta.adulto.cantidad
      } else {
        this.infoVenta.adulto.cantidad = 0
      }
    } else if (type === 'Infantil') {
      if (this.infoVenta.infantil.cantidad >= 1) {
        --this.infoVenta.infantil.cantidad
      } else {
        this.infoVenta.infantil.cantidad = 0
      }
    } else if (type === 'Discapacidad') {
      if (this.infoVenta.discapacidad.cantidad >= 1) {
        --this.infoVenta.discapacidad.cantidad
      } else {
        this.infoVenta.discapacidad.cantidad = 0
      }
    }
  }
}
